module.exports = function ($timeout) {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            if (scope.$last && attrs.olyRepeatFinished) {
                $timeout(function () {
                    scope.$eval(attrs.olyRepeatFinished);
                }, 0, false);
            }
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/repeatfinished/repeat-finished-directive.js
 **/